export default __webpack_public_path__ + "static/media/on-the-fly.90dbe7c9.svg";